import React, { useMemo } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Form, FormBody } from '../../../../components/Form/styles'

import { Button } from '../../../../components'
import Input from '../../../../components/Form/Input'
import { ButtonContainer } from './styles'
import { dateTypes } from '../../../../constants/date'
import dayjs from '../../../../helpers/dayjs'

const formSchema = Yup.object().shape({
  startDate: Yup.string().optional(),
  endDate: Yup.string().when('startDate', (startDate, schema) =>
    startDate
      ? schema.test(
          'endDate',
          'Data fim deve ser maior que a data início',
          (endDate) => !endDate || endDate > startDate
        )
      : schema
  )
})

const DashBoardFilters = ({ filters, setFilters, isLoading }) => {
  const onSubmit = async ({ startDate, endDate }) => {
    setFilters({
      ...(startDate && {
        start_date: dayjs(startDate, dateTypes.date).format(dateTypes.startDate)
      }),
      ...(endDate && {
        end_date: dayjs(endDate, dateTypes.date).format(dateTypes.endDate)
      })
    })
  }

  const initialValues = useMemo(() => {
    return {
      startDate: dayjs(filters.start_date, dateTypes.startDate).format(
        dateTypes.date
      ),
      endDate: dayjs(filters.end_date, dateTypes.endDate).format(dateTypes.date)
    }
  }, [filters])

  const handleCleanFilters = (setFieldValue) => () => {
    const newFilters = {
      start_date: dayjs().subtract(1, 'month').format(dateTypes.startDate),
      end_date: dayjs().format(dateTypes.endDate)
    }
    setFilters(newFilters)
    setFieldValue(
      'startDate',
      dayjs(newFilters.start_date, dateTypes.startDate).format(dateTypes.date)
    )
    setFieldValue(
      'endDate',
      dayjs(newFilters.end_date, dateTypes.endDate).format(dateTypes.date)
    )
  }

  return (
    <span>
      {initialValues.startDate && initialValues.endDate && (
        <Formik
          initialValues={initialValues}
          validationSchema={formSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form maxWidth="100%" margin="0">
              <FormBody type="flex" flexRow justifyContent="flex-start">
                <Input
                  type="date"
                  name="startDate"
                  label="Data início"
                  width="184px"
                  placeholder="Selecione"
                />
                <Input
                  type="date"
                  name="endDate"
                  label="Data fim"
                  width="200px"
                  placeholder="Selecione"
                />
                <ButtonContainer>
                  <Button
                    text="Filtrar"
                    type="submit"
                    variant="primary"
                    width="120px"
                    disabled={isSubmitting || isLoading}
                  />
                  <Button
                    text="Restaurar"
                    type="button"
                    variant="outlined"
                    width="120px"
                    disabled={isSubmitting}
                    onClick={handleCleanFilters(setFieldValue)}
                  />
                </ButtonContainer>
              </FormBody>
            </Form>
          )}
        </Formik>
      )}
    </span>
  )
}

export default DashBoardFilters
